import axios from 'axios';
import { backend_url } from '../constants';
import { getAccessToken } from '../graphql/client/utils';

if (
  process.env.NODE_ENV !== 'development' &&
  !process.env.REACT_APP_BACKEND_URL
) {
  throw new Error(
    'Backend URL is not configured. Please ensure the REACT_APP_BACKEND_URL environment variable is set in production.',
  );
}

const instance = axios.create({
  baseURL: backend_url,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  },
});

instance.interceptors.request.use(
  async (config) => {
    const token = getAccessToken();
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error);
    return Promise.reject(error);
  },
);

export default instance;
